import { BorderProps } from "components/common/LocationFields/LocationFields.types";
import styled from "styled-components";

export const PostsContainer = styled.div<{ border?: BorderProps, maxWidth?: string }>`
  border: ${({ border }) =>{
    const defaultWidth = "0.0625rem"
    const defaultStyle = "solid"
    const defaultColor = "rgb(4, 4, 4)"
    let borderInfo = [defaultWidth, defaultStyle, defaultColor]
    if(border){
      if(border.borderStyle){
        borderInfo[1] = border.borderStyle
      }
      
      if(border.borderWidth){
        borderInfo[0] = border.borderWidth
      }
      if(border.borderColor){
        borderInfo[2] = border.borderColor
      }
    }
    else{
      borderInfo = ["none", "none", "none"]
    }

    return borderInfo.join(" ")
  }};
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
  width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
  max-width: ${({ maxWidth }) => maxWidth || "100%"};
  white-space: nowrap;

  @media (max-width: 48rem) {
    padding: 0.75rem;
  }

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const SelectedContainer = styled.span`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const SelectedLabel = styled.div`
  padding: 0.1875rem;
  font-weight: 500;
`;

export const SelectedPosts = styled.div`
  background-color: #c4c4c4;
  padding: 0.1875rem 0.5rem;
  border-radius: 0.3125rem;
  font-size: 0.85rem;
`;

export const PostCard = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  margin: 0.75rem;
`;

export const PostTitle = styled.span`
  margin-top: 0.4rem;
  font-size: 0.8rem;
  max-width: 9.375rem;
  text-align: left;
  color: #4a4a4a;
  text-wrap:wrap;
`;

export const StyledImg = styled.img`
  margin: 0.75rem;
  border-radius: 0.375rem;
  cursor: pointer;
  object-fit: cover;
`;

export const RenderView = styled.div`
  position: static;
  overflow: scroll;
  inset: 0;
  margin-bottom: 0.3125rem;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Thumb = styled.div`
  background-color: #fe2f67;
  height: 1.25rem;
  border-radius: 50%;
  position: absolute;
  bottom: -0.25rem;
`;

export const Track = styled.div`
  padding: 0.3125rem;
  border: 0.0625rem solid #b8b8b8;
  border-radius: 0.3125rem;
  position: relative;
`;